var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23 17.5L20 21L19.2407 20.3492L21.2544 18L12 18L12 17L21.2544 17L19.2407 14.6508L20 14L23 17.5Z","fill":"#ED9C78"}));
}

ArrowInline.defaultProps = {"viewBox":"0 0 35 35","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
